/* Lente sorpresa de regalo — agrega y quita el regalo solo.
   El descuento «Regalo Cyber» (compra 1, lleva 1 gratis) NO agrega el producto al carrito: solo lo rebaja
   cuando ya está. Este script lo agrega cuando hay un lente de sol y lo quita si no hay lentes de sol
   o si el descuento no lo deja en $0 (cupo agotado, descuento apagado o incompatible con otro). */
(function () {
  var GIFT = 48185419792627;      /* variante de «Lente sorpresa de regalo» */
  var TIPO = 'Lentes de sol';
  var busy = false;

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {}
    return null;
  }
  function get() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }
  function avisar() { busy = true; document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true })); setTimeout(function () { busy = false; }, 600); }

  function revisar() {
    if (busy) return;
    get().then(function (cart) {
      var items = cart.items || [], tiene = false, gl = null;
      items.forEach(function (it) {
        if (it.variant_id === GIFT) gl = it;
        else if (it.product_type === TIPO) tiene = true;
      });

      if (!tiene) {                                   /* sin lentes de sol no hay regalo */
        ss('rkGiftOff', null); ss('rkGiftHad', null);
        if (gl) post('/cart/change.js', { id: String(gl.key), quantity: 0 }).then(avisar);
        return;
      }
      if (gl) {
        if (gl.final_price > 0) {                     /* el descuento no lo dejó en $0: fuera */
          ss('rkGiftOff', '1');
          post('/cart/change.js', { id: String(gl.key), quantity: 0 }).then(avisar);
        } else if (gl.quantity > 1) {
          post('/cart/change.js', { id: String(gl.key), quantity: 1 }).then(avisar);
        } else ss('rkGiftHad', '1');
        return;
      }
      if (ss('rkGiftHad')) { ss('rkGiftOff', '1'); ss('rkGiftHad', null); return; }   /* el cliente lo sacó */
      if (ss('rkGiftOff')) return;
      post('/cart/add.js', { items: [{ id: GIFT, quantity: 1 }] }).then(function (r) {
        if (r && r.status) return;                    /* sin stock u otro error: no insistir */
        get().then(function (c2) {
          var l = (c2.items || []).filter(function (i) { return i.variant_id === GIFT; })[0];
          if (l && l.final_price > 0) {               /* no quedó gratis: se retira */
            ss('rkGiftOff', '1');
            post('/cart/change.js', { id: String(l.key), quantity: 0 }).then(avisar);
          } else { ss('rkGiftHad', '1'); avisar(); }
        });
      });
    }).catch(function () {});
  }

  document.addEventListener('on:cart:change', function () { setTimeout(revisar, 250); });
  if (document.readyState !== 'loading') revisar(); else document.addEventListener('DOMContentLoaded', revisar);
})();
